import { PasswordValidator, MinLengthRule } from "../../core/services/password-validator.service";

export class ResetPasswordController {
    constructor(passwordValidatorService, $http, $window) {
        'ngInject';
        this.passwordValidatorService = passwordValidatorService;
        this.$http = $http;
        this.$window = $window;
        this.passwordValidator = new PasswordValidator([
            new MinLengthRule(true, 0),
            new MinLengthRule(true, 12)
        ]);
        this.password = "";
        this.confirmPassword = "";
        this.oldPassword = "";
        this.mfaCode = "";
        this.changeUserName = "";
        this.usernameChecking = false;
        this.usernameAvailable = true;
        this.usernameCheckEnabled = false;
    }

    loadValidator(userID, firstName, lastName) {
        this.passwordValidatorService.retrievePasswordValidator({
            EmployeeID: userID,
            FirstName: firstName,
            LastName: lastName
        }).then(validator => this.passwordValidator = validator);
    }

    /**
     * Return whether the entered password satisfies every required policy rule.
     * Used to keep the "Create Account" button disabled until the rules are met.
     */
    isPasswordValid() {
        return !!this.passwordValidator && this.passwordValidator.validate(this.password);
    }

    /**
     * Return whether the password and confirmation fields match. Requires a non-empty
     * password so an empty pair is not treated as a valid match.
     */
    passwordsMatch() {
        return !!this.password && this.password === this.confirmPassword;
    }

    /**
     * Return whether a current/old password has been entered. Only relevant on pages that
     * ask for the existing password (e.g. Change Password); other pages never gate on it.
     */
    currentPasswordEntered() {
        return !!(this.oldPassword && String(this.oldPassword).trim());
    }

    /**
     * Return whether an MFA verification code has been entered.
     */
    mfaCodeEntered() {
        return !!(this.mfaCode && String(this.mfaCode).trim());
    }

    /**
     * Enable the live (debounced) username availability check. Called from the onboarding page
     * only when the EnableOnboardingUsernameAvailabilityCheck feature flag is on.
     */
    enableUsernameCheck(enabled) {
        this.usernameCheckEnabled = !!enabled;
    }

    /**
     * Debounced handler for the optional "change username" field. Performs a live availability
     * check against the onboarding page's rate-limited CheckUsername handler. Fails open (treats
     * the name as available) so a check outage never blocks submission - the server re-validates.
     */
    onChangeUsername() {
        const name = (this.changeUserName || "").trim();
        if (!this.usernameCheckEnabled || !name) {
            this.usernameChecking = false;
            this.usernameAvailable = true;
            return;
        }
        this.usernameChecking = true;
        this.$http({
            method: "GET",
            url: this.$window.location.pathname,
            params: { handler: "CheckUsername", userName: name }
        }).then(response => {
            this.usernameAvailable = !!(response.data && response.data.available);
        }).catch(() => {
            this.usernameAvailable = true;
        }).finally(() => {
            this.usernameChecking = false;
        });
    }

    /**
     * Return whether the optional username change is acceptable: either left blank, or entered and
     * confirmed available (and not mid-check).
     */
    usernameChangeOk() {
        return !(this.changeUserName || "").trim()
            || (!this.usernameChecking && this.usernameAvailable);
    }
}
